import { type MaybeRefOrGetter, toValue } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import getPaginatedProjectList, {
  type PaginatedProjectList
} from '@/features/projects/get-paginated-project-list'
import type { SortedField } from '@/types'

export type { PaginatedProjectList }

type Options = {
  sorting: MaybeRefOrGetter<SortedField[]>
  filter: MaybeRefOrGetter<string | undefined>
  page: MaybeRefOrGetter<number | undefined>
  pageSize: MaybeRefOrGetter<number | undefined>
}

export function usePaginatedProjectList(options: Options) {
  return useQuery({
    queryKey: ['projects:list', options],
    placeholderData: (previousData) => previousData,
    queryFn: () =>
      getPaginatedProjectList({
        page: toValue(options.page),
        pageSize: toValue(options.pageSize),
        sorting: toValue(options.sorting),
        filter: toValue(options.filter)
      })
  })
}
